// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';
import moment from 'moment';
import App from './App';
import store from './store';
import router from './router';

// settings locale from globale variable *locale*
// cf. index.html & translationScript
moment.locale(locale);// eslint-disable-line

Vue.use(VueI18n);
Vue.use(Vuetify);

Vue.config.productionTip = false;

// settings localization from global variables :
const i18n = new VueI18n({
  locale, // eslint-disable-line
  messages, // eslint-disable-line
});

/* eslint-disable no-new */
new Vue({
  el: `#app`,
  template: `<App/>`,
  components: { App },
  router,
  store,
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js